/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useMutation
} from '@tanstack/react-query'
import type {
  UseMutationOptions,
  MutationFunction
} from '@tanstack/react-query'
import type {
  BinaryFile,
  ErrorInfo,
  DownLoadFileInfo
} from '.././model'


/**
 * ファイルダウンロード

 * @summary ファイルダウンロード
 */
export const postUtilsDownload = (
    downLoadFileInfo: DownLoadFileInfo, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/utils/download`,
      downLoadFileInfo,options
    );
  }



    export type PostUtilsDownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postUtilsDownload>>>
    export type PostUtilsDownloadMutationBody = DownLoadFileInfo
    export type PostUtilsDownloadMutationError = AxiosError<ErrorInfo>

    export const usePostUtilsDownload = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUtilsDownload>>, TError,{data: DownLoadFileInfo}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUtilsDownload>>, {data: DownLoadFileInfo}> = (props) => {
          const {data} = props ?? {};

          return  postUtilsDownload(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postUtilsDownload>>, TError, {data: DownLoadFileInfo}, TContext>(mutationFn, mutationOptions)
    }
    